import React from "react";
import { TextField } from "@c4c-web/ui";
import { EAddressType } from "../../../constants";
import type { IFormFieldsProps } from "./AddressFormFields";

export const DefaultFormFields: React.FC<IFormFieldsProps> = ({
  addressFormStates,
  errors,
  formData,
  register,
  t,
}) => {
  const addressType = addressFormStates?.otherStates.addressType[0];

  const showApartmentField = addressType
    ? [EAddressType.HOME, EAddressType.OFFICE].includes(
        addressType.toLowerCase() as EAddressType,
      )
    : false;

  return (
    <div className="flex flex-col gap-sm">
      {showApartmentField ? (
        <div>
          <TextField
            defaultValue={formData?.appartment}
            id="appartment"
            label={
              addressType?.toLowerCase() === EAddressType.OFFICE.toString()
                ? t("addressJourney.addressForm.officeNumber")
                : t("addressJourney.addressForm.appartment")
            }
            {...register("appartment", { required: true })}
            error={Boolean(errors.appartment)}
            haveBoldText
            helperText={
              errors.appartment ? t("addressJourney.error.appartment") : ""
            }
            placeholder={t(
              "addressJourney.addressForm.placeHolders.appartment",
            )}
          />
        </div>
      ) : null}
      <div>
        <TextField
          defaultValue={formData?.building}
          id="building"
          label={t("addressJourney.addressForm.building")}
          {...register("building", { required: true })}
          error={Boolean(errors.building)}
          haveBoldText
          helperText={errors.building ? t("addressJourney.error.building") : ""}
          placeholder={t("addressJourney.addressForm.placeHolders.building")}
        />
      </div>
      <div>
        <TextField
          defaultValue={formData?.streetName}
          id="street"
          label={t("addressJourney.addressForm.street")}
          {...register("streetName", { required: true })}
          error={Boolean(errors.streetName)}
          haveBoldText
          helperText={errors.streetName ? t("addressJourney.error.street") : ""}
          placeholder={t("addressJourney.addressForm.placeHolders.street")}
        />
      </div>
    </div>
  );
};
